export default __webpack_public_path__ + "static/media/i124hp.b5aa64ff.webp";